import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  AgingCategory,
  AgingTimeUnit,
  BarrelType,
  BrandyType,
  BrandyOrWinebrandType,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { CognacProperties } from '@app/api/models';

@Component({
  selector: 'app-cognac-properties-subform',
  templateUrl: './cognac-properties-subform.component.html',
  styleUrls: ['./cognac-properties-subform.component.scss'],
})
export class CognacPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.COGNAC_PROPERTIES';

  brandyTypes = BrandyType;
  brandyOrWinebrandTypes = BrandyOrWinebrandType;
  agingCategories = AgingCategory;
  agingTimeUnits = AgingTimeUnit;
  barrelTypes = BarrelType;

  Validators = Validators;

  static buildForm(
    fb: FormBuilder,
    data: CognacProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    return fb.group({
      brandyType: [data?.brandyType, Validators.required],
      ...(data?.brandyType === BrandyType.BrandyOrWinebrand && {
        brandyOrWinebrandType: [
          data?.brandyOrWinebrandType,
          Validators.required,
        ],
      }),
      agingCategory: [data?.agingCategory],
      agingTime: [data?.agingTime],
      agingTimeUnit: [
        data?.agingTimeUnit,
        data?.agingTime ? [Validators.required] : [],
      ],
      ...(!isSecondaryProductSheet && {
        barrelType: [data?.barrelType],
      }),
    });
  }

  onCognacTypeSelected(selected?: BrandyType) {
    if (selected === BrandyType.BrandyOrWinebrand) {
      this.group.addControl(
        'brandyOrWinebrandType',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.group.removeControl('brandyOrWinebrandType');
    }
  }
}
